<template>
  <button
    type="button"
    class="btn btn-primary btn-floating btn-lg"
    id="btn-back-to-top"
    ref="mybutton"
    @click="backToTop"
  >
    <i class="fas fa-arrow-up"></i>
  </button>
  <Navbar/>
  <div class="p-4">
    <div class="d-flex justify-content-between">
      <div>
        <h5 class="fw-bold">
          EDYCJA DANYCH KIEROWCY
        </h5>
      </div>
      <div>
        <router-link :to="{ name: 'DriversListing' }" class="btn btn-primary">
          <i class="fa-solid fa-arrow-left"></i>
          Powrót do listy kierowców
        </router-link>
      </div>
    </div>
    <form @submit.prevent="UpdateDriver()">

      <div class="mb-3">
        <label for="place-name" class="form-label">Imię: </label>
        <input type="text" class="form-control" id="place-name" v-model="employee.firstName" placeholder="Imię">
      </div>

      <div class="mb-3">
        <label for="place-name" class="form-label">Nazwisko: </label>
        <input type="text" class="form-control" id="place-name" v-model="employee.surname" placeholder="Nazwisko">
      </div>

      <div class="mb-3">
        <label for="place-name" class="form-label">Nr karty: </label>
        <input type="text" class="form-control" id="place-name" v-model="employee.cardNumber" placeholder="Nr karty">
      </div>

      <div class="mb-3" style="width: 100%; display: flex; align-items: center; justify-content: space-between;">
        <div style="width: 49%;">
            <label for="place-name" class="form-label">Nr kierunkowy: </label>
            <input type="text" class="form-control" id="place-name" v-model="employee.phonePrefix" placeholder="Nr kierunkowy">
        </div>

        <div style="width: 49%;">
            <label for="place-name" class="form-label">Nr telefonu: </label>
            <input type="text" class="form-control" id="place-name" v-model="employee.phoneNumber" placeholder="Nr telefonu">
        </div>
      </div>

      <div class="mb-3">
        <label for="place-name" class="form-label">Numer dowodu osobistego: </label>
        <input type="text" class="form-control" id="place-name" v-model="employee.workNumber" placeholder="numer dowodu osobistego">
      </div>

      <button type="submit" class="btn btn-primary w-100">
        Zatwierdź
      </button>
    </form>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import axios from 'axios'
import Swal from 'sweetalert2'
import { $axios } from '@/modules/http/axios'
export default {
  name: 'VehicleEditor',
  components: { Navbar },
  data () {
    return {
      employee: {
        name: '',
        surname: '',
        phonePrefix: '',
        phoneNumber: ''
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.scrollFunction)
  },
  mounted () {
    this.GetDriver()
  },
  methods: {
    UpdateDriver () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

      axios.put(`${process.env.VUE_APP_API_BASE_URL}Driver/${this.$route.params.id}`,this.employee ,config)
        .then(response => {
          Swal.fire({
            title: 'Sukces!',
            text: 'Dane pracownika zostały zaktualizowane!',
            icon: 'success',
            type: 'success'
          })
          this.$router.push({ name: 'DriversListing' })
        })

    },
    GetDriver () {
      $axios.get(`Driver/${this.$route.params.id}`)
        .then(response => {
          this.employee = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    DeleteDriver () {
      Swal.fire({
        title: 'Usunąć tego kierowcę?',
        text: 'Jesteś pewien że chcesz usunąć tego kierowcę?',
        type: 'warning',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Usuń'
      }).then((result) => {
        const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

        axios.delete(process.env.VUE_APP_API_BASE_URL + 'Driver/' + this.$route.params.id, config)
          .then(response => {
            Swal.fire(
              'Usunięto!',
              'Kierowca został usunięty.',
              'success'
            )
            this.$router.push({ name: 'DriversListing' })
          })
      })
    },
    scrollFunction () {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'block'
        }
      } else {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'none'
        }
      }
    },
    backToTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style scoped>
#btn-back-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: none;
}
</style>
